import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useNotFoundRedirect = (error: any, redirectOnMissingData: boolean = false) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (!error && !redirectOnMissingData) return;

    const shouldRedirect =
      error?.status === 404 ||
      error?.error?.status === 404 ||
      error?.status === '404' ||
      error?.error?.status === '404' ||
      error?.originalStatus === 404 ||
      error?.error?.originalStatus === 404 ||
      error?.status === 400 ||
      error?.error?.status === 400 ||
      error?.status === '400' ||
      error?.error?.status === '400' ||
      error?.originalStatus === 400 ||
      error?.error?.originalStatus === 400 ||
      error?.data?.detail?.toLowerCase().includes('not found') ||
      error?.data?.message?.toLowerCase().includes('not found') ||
      error?.error?.data?.detail?.toLowerCase().includes('not found') ||
      redirectOnMissingData;

    if (shouldRedirect) {
      navigate('/404', { replace: true });
    }
  }, [error, navigate, redirectOnMissingData]);
};
